import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import {
  getEventListCount,
  getEventListFetched,
  getEventListTotal,
} from '../../state/reducers';

import EventListCounter from './EventListCounter.react';

/**
 * Event list counter container element
 * Wraps the event list counter presentational component with Redux state
 */
export const EventListCounterContainer = ({ count, fetched, total }) => (
  fetched
    ? <EventListCounter count={count} total={total} />
    : null
);

EventListCounterContainer.propTypes = {
  /**
   * Number of events loaded in current state event list
   */
  count: PropTypes.number.isRequired,
  /**
   * Boolean describing whether the list has been fetched at all
   */
  fetched: PropTypes.bool.isRequired,
   /**
    * Number of events for current list (and query) found on the server
    */
  total: PropTypes.number.isRequired,
};

// Selectors are used so state shape is encapsulated within reducers
const mapStateToProps = (state, { query }) => ({
  count: getEventListCount(state, query),
  fetched: getEventListFetched(state, query),
  total: getEventListTotal(state, query),
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const EventListCounterContainerWithRedux = connect(mapStateToProps)(EventListCounterContainer);

export default EventListCounterContainerWithRedux;



// WEBPACK FOOTER //
// ./app/src/components/EventListCounter/EventListCounterContainer.react.js